import React from "react";
import {ColumnProps} from "../Types/ColumnProps";
import {FilterType} from "../Types/FilterType";

export type FilterProps = ColumnProps & {
    filter?: FilterType,
    filterField?: string,
    filterOperator?: string,
    filterOpened: boolean,
    setFilter: (filter: FilterType|undefined|null) => void,
    setFilterOpened: (filterOpened: boolean) => void,
}

export default class Filter extends React.Component<FilterProps, any> {
}